import { ModelBase } from './base';

export class Category extends ModelBase{
  name: string;
  store_id: number;
  is_active: boolean;
  slider_image: string;
}


// WEBPACK FOOTER //
// ./src/models/category.ts